import React from "react";
import BoardCardShell from "../BoardCardShell";
import BoardChartRegion from "../BoardChartRegion";
import BoardCardState from "../BoardCardState";
import CustomChartCard from "features/analytics/studio/components/board/CustomChartCard";

const BADGE = { label: "Custom", bg: "var(--surface-sunken)", color: "var(--text-muted)" };

export default function CustomChartBoardCard({ card, onDelete, readOnly }) {
  const cfg = card?.queryDsl;
  const hasData = cfg && typeof cfg === "object" && Array.isArray(cfg.data) && cfg.data.length > 0;

  const actions = readOnly ? [] : [
    ...(onDelete ? [{ label: "Delete", icon: "delete", onClick: onDelete, danger: true }] : []),
  ];

  const subtitle = cfg?.subtitle || null;

  return (
    <BoardCardShell
      title={card?.title || "Chart"}
      subtitle={subtitle}
      badge={BADGE}
      actions={actions}
      readOnly={readOnly}
    >
      {!hasData ? (
        <BoardCardState state="empty" message="No chart data" />
      ) : (
        <BoardChartRegion>
          {() => (
            <div className="w-full h-full">
              <CustomChartCard card={card} />
            </div>
          )}
        </BoardChartRegion>
      )}
    </BoardCardShell>
  );
}
